import { ReactNode } from 'react';
import styled from 'styled-components';

import Tooltip from 'components/shared/Tooltip';
import { colors } from 'styles/theme/colors';
import InfoIconOutline from 'svg/InfoIconOutline';

type Props = {
  label: string;
  info: ReactNode;
  ariaLabel?: string;
  position?: 'top' | 'bottom';
};

// A column header with an info icon that reveals `info` on hover. The trigger swallows its click
// because a sortable header toggles its sort on click.
export default function InfoHeader({ label, info, ariaLabel = `About ${label}`, position = 'bottom' }: Props) {
  return (
    <HeaderWithInfo>
      {label}
      <Tooltip text={info} position={position}>
        <InfoTrigger type='button' aria-label={ariaLabel} onClick={(e) => e.stopPropagation()}>
          <InfoIconOutline width={14} height={14} />
        </InfoTrigger>
      </Tooltip>
    </HeaderWithInfo>
  );
}

const HeaderWithInfo = styled.span`
  display: inline-flex;
  align-items: center;
  gap: 4px;
`;

const InfoTrigger = styled.button`
  display: inline-flex;
  align-items: center;
  padding: 0;
  border: none;
  background: transparent;
  color: ${colors.black50};
  cursor: pointer;
`;
